import { BaseController } from '../../../../../common/base/controller';

export class SuccessfulSubmitController extends BaseController {
  constructor(controllerService, receivingService, ticketStateName) {
    'ngInject';
    super({ controllerService, receivingService, ticketStateName });
  }

  $onInit() {
    this.breadcrumbs = this.receivingService.states;

    if (this.userService.isCustomerEntryUser()) {
      this.userService.logout();
    }
  }

  get successfulSubmitInfoMessage() {
    if (this.ticket.warrantShipmentSkipped) {
      return 'app.receiving.successfulSubmit.WarrantShipmentSkipped.info';
    }

    return `app.receiving.successfulSubmit.${this.ticket.guidanceType}.info`;
  }

  get showInfo() {
    return !this.isFeatureActive(
      this.FeatureNames.FF_DISABLE_VERIFYING_FINANCES,
    );
  }

  get successfulSubmitBodyMessage() {
    return this.ticket.warrantShipmentSkipped
      ? 'app.receiving.successfulSubmit.warrantShipmentSkipped.body'
      : 'app.receiving.successfulSubmit.body';
  }

  navigateToTicket() {
    const { ticketStateName, ticket } = this;

    this.go(ticketStateName, { ticketId: ticket.id });
  }
}
